<template>
  <div class="modal-inner" :class="type">
    <div class="top-right" @click="$modal.hide(modalName)">
      <font-awesome-icon icon="times" class="close-icon" :id="`close-${modalName}`"></font-awesome-icon>
    </div><!-- /.top-right -->
    <font-awesome-icon icon="exclamation-triangle" class="icon" v-if="type=='warning'"></font-awesome-icon>
    <font-awesome-icon icon="exclamation-circle" class="icon" v-if="type=='error'"></font-awesome-icon>
    <font-awesome-icon icon="check-circle" class="icon" v-if="type=='success'"></font-awesome-icon>
    <h1>{{title}}</h1>
    <p class="warning-text">{{contents}}</p>
    <div
      class="btn"
      :id="`${modalName}-btn`"
      v-if="buttonText"
      @click="actionOkay"
    >{{buttonText}}</div>
  </div><!-- /.modal-inner -->
</template>

<script>
import { validateModalType } from "@/helpers/validation";

export default {
  name: "MessageModal",
  props: {
    type: {
      type: String,
      required: false,
      default: "default",
      validator: function(type) {
        return validateModalType(type);
      },
    },
    title: {
      type: String,
      required: true,
    },
    contents: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: false,
    },
    modalName: {
      type: String,
      required: true,
    },
  },
  methods: {
    actionOkay () {
      this.$emit('okay-action');
      this.$modal.hide(this.modalName)
    },
  },
};
</script>
